<div class="footer">
  <div class="footer__inner">
    <div class="footer__language">
      <app-language-select></app-language-select>
    </div>
    <div class="footer__branding">
      @if (!hideBrandingText) {
        <span class="footer-text">
          &copy; {{ thisYear }} Children's Miracle Network - v:{{ version }}
        </span>
      }
    </div>
  </div>
</div>
